import { Pipe, PipeTransform } from '@angular/core';

import { formatCnpj, unformatCnpj } from '../../core/utils/cnpj.util';

@Pipe({
  name: 'cnpj',
  standalone: true
})
export class CnpjPipe implements PipeTransform {
  transform(value: string): string {
    return formatCnpj(value);
  }

  removeCnpjMask(value: string): string {
    return unformatCnpj(value);
  }
}
